import React from 'react';
import PropTypes from 'prop-types';

import styles from './options.scss';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';

class OptionChoice extends React.Component {
    static propTypes = {
        selectionHandler: PropTypes.func.isRequired,
        isSelected: PropTypes.bool,
        title: PropTypes.string.isRequired,
        identifier: PropTypes.string.isRequired,
        language: PropTypes.string,
        imageSrc: PropTypes.string,
        a11yLabel: PropTypes.string,
    };

    onClick = () => {
        this.props.selectionHandler(this.props.identifier);
    };

    render() {
        const { isSelected, language, title, imageSrc, a11yLabel } = this.props;
        const className = `${styles.optionItem} ${styles.optionChoice} ${imageSrc ? styles.contrastOptionIconPadding : ''}`;

        return (
            <button
                className={className}
                aria-pressed={isSelected}
                onClick={this.onClick}
                {...getA11yAttributesV2({ 'aria-label': a11yLabel || title })}
            >
                {
                    isSelected
                        ? <i className="fa fa-check fa-fw" aria-hidden="true" />
                        : <i className="fa fa-fw" aria-hidden="true" />
                }
                <span lang={language}>{title}</span>
                {imageSrc && <img className={styles.contrastOptionIcon} alt="" aria-hidden="true" src={imageSrc} />}
            </button>
        );
    }
}

class OptionsChoiceList extends React.Component {
    static propTypes = {
        selectionHandler: PropTypes.func.isRequired,
        choices: PropTypes.array.isRequired,
        a11yLabel: PropTypes.string,
    };

    makeChoices = () => {
        const { choices } = this.props;
        return choices.map((choice) => {
            return (<OptionChoice
                {...choice}
                selectionHandler={this.props.selectionHandler}
                key={choice.identifier}
            />);
        });
    };

    render() {
        if (this.props.choices.length === 0) {
            return null;
        }

        const choiceItems = this.makeChoices();
        return (
            <ul
                className={styles.buttonGroup}
                {...getA11yAttributesV2({ 'aria-label': this.props.a11yLabel })}
            >
                {choiceItems}
            </ul>
        );
    }
}

export default OptionsChoiceList;
